import { useMemo } from "react";

import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import Dialog from "components/dialog";

interface MicUnverifiedPromptDialogProps {
  open: boolean;
  onRunSetup: () => void;
  onProceedAnyway: () => void;
  onCancel: () => void;
  isFirstTime?: boolean;
}

export default function MicUnverifiedPromptDialog({
  open,
  onRunSetup,
  onProceedAnyway,
  onCancel,
  isFirstTime = false
}: MicUnverifiedPromptDialogProps) {
  const theme = useTheme();

  const sx = useMemo(
    () => ({ zIndex: theme.zIndex.snackbar + 10 }),
    [theme.zIndex.snackbar]
  );

  return (
    <Dialog
      title="Microphone Check"
      onClose={onCancel}
      open={open}
      sx={sx}
    >
      <Typography variant="body3">
        {isFirstTime
          ? "Your microphone hasn\u2019t been set up yet. Run a quick check to make sure everything\u2019s working before you start?"
          : "We suspect your microphone isn\u2019t working. Let\u2019s run a quick microphone check."}
      </Typography>
      <DialogActions sx={{ mt: 3, mb: -4 }}>
        <Button variant="outlined" size="small" onClick={onProceedAnyway}>
          No, proceed anyway
        </Button>
        <Button variant="contained" size="small" onClick={onRunSetup}>
          Yes, run mic check
        </Button>
      </DialogActions>
    </Dialog>
  );
}
